export default __webpack_public_path__ + "static/media/services_invites.5720a7f1.jpg";